import React from "react";
import { Instagram } from "lucide-react";
import { BRAND, IMAGES } from "../data/content";

const TILES = [IMAGES.jerkTray, IMAGES.dessertCake, IMAGES.beefPatty, IMAGES.oxtailPlate, IMAGES.rastaPasta, IMAGES.plantains];

export default function InstagramSection() {
  return (
    <section data-testid="instagram-section" className="bg-charcoal py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="eyebrow text-gold mb-3">@{BRAND.instagram}</div>
        <h2 className="text-3xl sm:text-4xl font-serif font-semibold text-white">Follow the Flavor</h2>
        <p className="mt-4 max-w-xl mx-auto text-platinum">
          Follow @{BRAND.instagram} for delicious updates, featured dishes, behind-the-scenes content, and more.
        </p>

        <div className="mt-10 grid grid-cols-3 sm:grid-cols-6 gap-2 sm:gap-3">
          {TILES.map((src, i) => (
            <a
              key={i}
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="group relative aspect-square overflow-hidden rounded-lg"
            >
              <img src={src} alt="Taste of Platinum dish" loading="lazy"
                   className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-charcoal/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <Instagram className="w-6 h-6 text-white" />
              </div>
            </a>
          ))}
        </div>

        <a
          href={BRAND.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-button"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3 font-semibold text-charcoal hover:bg-gold-bright transition-colors"
        >
          <Instagram className="w-5 h-5" /> Follow @{BRAND.instagram}
        </a>
      </div>
    </section>
  );
}
